import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import abbreviateNumber from 'flarum/common/utils/abbreviateNumber';
import { slug } from '../../common';

export default class CurrentlyOnlineStat extends Component {
	view() {
		const value = app.forum.attribute<number>('onlineUsers') ?? 0;

		if (value <= 0) return null;

		return (
			<div className="CurrentlyOnlineStat">
				<div className="HomeStats-stat HomeStats-stat--currentlyOnline">
					<div className="HomeStats-stat-valueWrapper">
						<span className="HomeStats-stat-value">{abbreviateNumber(value)}</span>
						<span className="HomeStats-stat-label">{app.translator.trans(`${slug}.forum.home.stats.currentlyOnline`, { count: value })}</span>
					</div>
				</div>
			</div>
		);
	}
}
